<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div
      class="absolute inset-0 bg-black/85"
      @click="$emit('close')"
    ></div>

    <div class="relative w-full max-w-160 max-h-[90vh] flex flex-col rounded-lg bg-nera-container overflow-hidden shadow-2xl">
      <header class="flex items-center justify-between px-5 py-4 bg-nera-elevated-2 border-b border-nera-border">
        <p class="text-nera-text font-semibold">Select Files</p>
        <button
          @click="$emit('close')"
          aria-label="Close"
          class="w-6 h-6 inline-flex items-center justify-center rounded-full bg-nera-light-hover text-nera-text text-lg leading-none transition-colors hover:bg-nera-border"
        >×</button>
      </header>

      <section class="flex-1 overflow-y-auto p-5 bg-nera-container text-nera-text">
        <div v-if="availableFiles.length === 0" class="text-center text-nera-muted-light">
          <p>No files available</p>
        </div>

        <div v-else class="flex flex-col gap-2">
          <div
            v-for="file in availableFiles"
            :key="file.id"
            @click="$emit('attach', file.id)"
            class="flex items-center gap-4 p-4 rounded-lg border border-nera-border bg-nera-ai-msg cursor-pointer transition-all duration-200 hover:border-nera-accent hover:bg-nera-accent/10"
          >
            <span class="text-2xl text-nera-accent">
              <i :class="getFileIcon(file.type)"></i>
            </span>
            <div class="flex-1 flex flex-col gap-1">
              <strong class="text-nera-text">{{ file.name }}</strong>
              <small class="text-nera-muted">{{ formatSize(file.size) }} • {{ formatDate(file.created_at) }}</small>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  conversationId: Number,
  excludedFileIds: {
    type: Array,
    default: () => []
  }
})

defineEmits(['attach', 'close'])

const loading = ref(true)
const availableFiles = ref([])

onMounted(async () => {
  try {
    const response = await fetch('/api/files', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })

    if (response.ok) {
      const files = await response.json()
      availableFiles.value = files.filter(f => !props.excludedFileIds.includes(f.id))
    }
  } catch (error) {
    console.error('Failed to load files:', error)
  } finally {
    loading.value = false
  }
})

const getFileIcon = (type) => {
  if (type?.includes('csv')) return 'fas fa-file-csv'
  if (type?.includes('excel') || type?.includes('spreadsheet')) return 'fas fa-file-excel'
  return 'fas fa-file'
}

const formatSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
}

const formatDate = (dateStr) => {
  return new Date(dateStr).toLocaleDateString()
}
</script>
